<template>
  <div class="autocomplete-input-wrapper"
    tabindex="0"
    @focusout="onBlurWrapper"
    @keyup.enter="emitValue">
    <InputVue
      :name="name"
      :label="label"
      :tabindex="0"
      :cssClasses="cssClasses"
      :labelAsPlaceholder="labelAsPlaceholder"
      :hasError="hasError">
      <template #input-slot>
        <input 
          ref="input"
          class="form-control" 
          autocomplete="off"
          :name="name" 
          type="text"
          @keyup="onInput"
          @focus="toggleSuggestions"
          @keydown.tab="onTabSuggestion(1)"
          :placeholder="labelAsPlaceholder ? label : placeholder " />
      </template>
    </InputVue>

    <ul class="autocomplete-suggestions-cont" v-show="showSuggestions">
      <li v-for="(option,i) in suggestions"
        :key="i"
        :tabindex="i"
        :data-index="i"
        :data-last="i === suggestions.length - 1"
        :data-suggestion="option"
        :class="{highlighted:highlighted === i}"
        class="suggestion"
        @keydown.tab="onTabSuggestion(1)"
        @keydown.shift.tab="onTabSuggestion(-1)">
        {{option}}
      </li>
    </ul>
  </div>
</template>

<script>
import InputVue from './InputCompVue'

export default {
  name: 'AutocompleteInputVue',

  props: {
    name: String,
    label: String,
    focus: Boolean,
    cssClasses: String,
    labelAsPlaceholder: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    allSuggestions: Array,
    urlSuggestions: false,
  },

  data() {
    return {
      nonCharKeys: [
        'Shift',
        'Alt',
        'Control',
        'Tab',
        'ArrowUp',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'Enter',
        'Backspace',
        'Escape',
      ],
      hasError: false,
      errors: { hasError: 'error' },
      stub: '',
      suggestion: '',
      showSuggestions: false,
      value: '',
      highlighted: -1,
      hasSuggestion: false,
    }
  },

  computed: {
    suggestions() {
      return this.allSuggestions.filter(s => s.includes(this.stub.trim())).slice(0, 10)
    },
  },

  methods: {
    onBlurWrapper(e) {
      if (!e.relatedTarget) {
        this.showSuggestions = false
      }
    },

    updateValue(e) {
      this.emitValue(e.target.value)
    },

    emitValue() {
      this.$emit('value:submitted', this.$refs.input.value)
    },

    toggleError() {
      this.hasError = !this.hasError
    },

    setInput(value) {
      this.$refs.input.value = value
    },

    focusInput(value, focusEnd=false) {
      this.$refs.input.focus()
      if (value) {
        this.setInput(value)
        if (!focusEnd) {
          this.$refs.input.setSelectionRange(this.stub.length, value.length)
          this.hasSuggestion = true
        }
      }
    },

    onInput(e) {
      e.preventDefault()
      const key = e.key
      if (key === 'ArrowUp' || key === 'ArrowDown') {
        return this.scrollSuggestions(key)
      }
      if (key === 'Backspace' && !this.hasSuggestion) {
        this.stub = this.stub.slice(0, this.stub.length - 1)
      } else if (key === 'Backspace') {
        this.hasSuggestion = false
      //} else if (key === 'Escape') {
      } else if (!this.nonCharKeys.includes(key)) {
        this.stub += key
        this.updateSuggestion()
      } 
      this.highlighted = -1
      this.toggleSuggestions()
    },

    toggleSuggestions() {
      if (this.stub.length > 0 && this.suggestions.length > 0) {
        this.showSuggestions = true
      } else {
        this.showSuggestions = false
      }
    },

    scrollSuggestions(key) {
      if (key === 'ArrowUp') {
        this.scrollUp()
      } else if (key === 'ArrowDown') {
        this.scrollDown()
      }
      if (this.highlighted === -1) {
        this.focusInput()
      }
    },

    scrollUp() {
      this.highlighted -= 1
      if (this.highlighted === -2) {
        this.highlighted = this.suggestions.length - 1
      } else {
        this.focusInput(this.suggestions[this.highlighted])
      }
    },

    scrollDown() {
      this.highlighted += 1
      if (this.highlighted >= this.suggestions.length) {
        this.highlighted = -1
      } else {
        this.focusInput(this.suggestions[this.highlighted])
      }
    },

    updateSuggestion() {
      const value = this.suggestions.find(s => s.startsWith(this.stub))
      if (this.showSuggestions && value) {
        this.focusInput(value)
      }
    },

    onTabSuggestion(i) {
      this.highlighted += i
      if (this.highlighted < 0 || this.highlighted >= this.suggestions.length) {
        this.highlighted = -1
        this.focusInput()
      } else {
        this.focusInput(this.suggestions[this.highlighted])
      }
    },
  },

  mounted() {
    if (this.focus) this.focusInput()
  },

  created() {
  },

  components: {
    InputVue,
  },
}
</script>

<style lang="scss" scoped>
.autocomplete-input-wrapper {
  position: relative;

  .search-input {
    margin: 0;
  }

  .autocomplete-suggestions-cont {
    width: 100%;
    z-index: 10;
    border: 1px solid color(primary);
    background-color: color(surface-bright);
    position: absolute;
    padding: $paddingSmall;
    text-align: left;
    margin: 0;

    .suggestion {
      list-style: none;
      color: color(secondary);
      padding: $paddingXSmall;
      text-align: left;

      &.highlighted {
        background-color: color(surface-variant);
      }

      &:focus {
        //background-color: color(surface-variant);
        outline: none;
      }
    }
  }
}
</style>
